module.exports = __webpack_public_path__ + "static/media/node.271dda26.svg";